import { render } from "./directory.html?vue&type=template&id=517fb56b&ts=true"
import script from "./directory.vue?vue&type=script&lang=ts"
export * from "./directory.vue?vue&type=script&lang=ts"

import "./directory.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__